import { createSelector } from 'reselect';
import { ApplicationRootState } from '../../types';
import { initialState } from './reducer';

const selectCustomerSupport = (state: ApplicationRootState) => state.customerSupport || initialState;

const makeSelectCustomerSupport = () =>
  createSelector(
    selectCustomerSupport,
    substate => substate,
  );

export default makeSelectCustomerSupport;
export { selectCustomerSupport };
